import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const MagazineIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M20.1818 4.47047C19.1727 4.14105 18.0636 3.99988 17 3.99988C15.2273 3.99988 13.3182 4.37635 12 5.41164C10.6818 4.37635 8.77273 3.99988 7 3.99988C5.22727 3.99988 3.31818 4.37635 2 5.41164V19.1999C2 19.4352 2.22727 19.6705 2.45455 19.6705C2.54545 19.6705 2.59091 19.6234 2.68182 19.6234C3.90909 19.0116 5.68182 18.5881 7 18.5881C8.77273 18.5881 10.6818 18.9646 12 19.9999C13.2273 19.1999 15.4545 18.5881 17 18.5881C18.5 18.5881 20.0455 18.8705 21.3182 19.5763C21.4091 19.6234 21.4545 19.6234 21.5455 19.6234C21.7727 19.6234 22 19.3881 22 19.1528V5.41164C21.4545 4.98811 20.8636 4.70576 20.1818 4.47047ZM20.1818 17.1763C19.1818 16.8469 18.0909 16.7058 17 16.7058C15.4545 16.7058 13.2273 17.3175 12 18.1175V7.294C13.2273 6.494 15.4545 5.88223 17 5.88223C18.0909 5.88223 19.1818 6.02341 20.1818 6.35282V17.1763Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
